import { Component, Inject, OnInit, Input } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ReceivedLabSampleService } from "../../../services/received-lab-sample/received-lab-sample.service";
import { ReceivedLabSample } from "../../../model/received-lab-sample/received-lab-sample";
import { NotificationToastService } from "../../../services/notification-toast.service";


export interface ReceivedLabSampleDialogData {
  medicalAppointmentId: number;
  isAdmission: boolean;
}


@Component({
  selector: "app-received-lab-sample-dialog",
  templateUrl: "./received-lab-sample-dialog.component.html",
  styleUrls: ["./received-lab-sample-dialog.component.css"],
})
export class ReceivedLabSampleDialogComponent implements OnInit {
  loading: boolean;
  items: ReceivedLabSample[] = [];

  constructor(
    private receivedLabSampleService: ReceivedLabSampleService,
    private notificationToastService: NotificationToastService,
    public dialogRef: MatDialogRef<ReceivedLabSampleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReceivedLabSampleDialogData
  ) {}

  async ngOnInit() {
    try {
      this.loading = true;
      let id = this.data.medicalAppointmentId;
      this.items = await this.receivedLabSampleService.get(
        id, this.data.isAdmission
      );
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Otros turnos"
      );
    } finally {
      this.loading = false;
    }
  }

  async update() {
    try {

      if (!this.data.isAdmission) {
        this.loading = true;
        await this.receivedLabSampleService.update(this.items);
        this.dialogRef.close(false);
      }

    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Otros turnos"
      );
    } finally {
      this.loading = false;
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
